import * as React from "react";

import styled from "styled-components";
import {device} from "./breakpoints";
import {ChangeEvent, useState} from "react";

const Container = styled.div`
  padding: 12px;
  font-family: "MuseoSansRounded-300";
  color: #fff;
  width: 100%;
  max-width: 800px;
  height: 100vh;
  background: #005AA4;
  border-radius: 20px;
  flex-direction: column;
  text-align: center;
  
  @media only screen and ${device.mobile} {
    flex-direction: row;
    height: 400px;
  }
`;

const MainHeading = styled.h2`
    font-weight: 100;
`;

const SubHeading = styled.h3`
    font-weight: 100;
`;

const InputWrapper = styled.div`
    display: flex;
    justify-content: center;
`

const TextInput = styled.input`
    border-radius: 6px;
    border: 1px solid black;
    padding: 8px;
    text-align: right;
    margin: 16px;
    flex: 1;
    max-width: 200px;
    width: 50%;
`;

const CalculateButton = styled.button`
    background-color: #f9e6d9;
    border-radius: 16px;
    border: 1px solid black;
    padding: 8px 16px;
    
    &:focus {
        border: none;
        outline: none;
    }
`;

const interest = [
    {
        high: 0,
        medium: 0,
        low: 0
    },
    {
        high: 1.75,
        medium: 1.00,
        low: 0.70
    },
    {
        high: 3.50,
        medium: 1.90,
        low: 1.40
    },
    {
        high: 5.25,
        medium: 2.85,
        low: 2.10
    },
    {
        high: 7.00,
        medium: 3.80,
        low: 2.80
    },
    {
        high: 8.00,
        medium: 6.50,
        low: 5.50
    }
]

export const Calculator = () => {

    const [invoiceAmount, setInvoiceAmount] = useState("")
    const [creditPeriod, setCreditPeriod] = useState("")
    const [showResult, setShouldShowResult] = useState(false)

    const onChangeInvoiceAmount = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        event.stopPropagation()
        console.log(event.currentTarget.value)
        const amount = event.currentTarget.value.replace(/\s/g, "")
        console.log(amount)
        setInvoiceAmount(amount)
    }

    const onChangeCreditPeriod = (event: ChangeEvent<HTMLInputElement>) => {
        const period = event.currentTarget.value.replace(/ /g, "")
        setCreditPeriod(period)
        //setCreditPeriod(parseInt(period))
    }

    function extracted() {
        let feePercent;
        const period = parseInt(creditPeriod === "" ? "0" : creditPeriod)
        if (period === 0) {
            feePercent = interest[0]
        } else if (period <= 14) {
            feePercent = interest[1]
        } else if (period <= 30) {
            feePercent = interest[2]
        } else if (period <= 45) {
            feePercent = interest[3]
        } else if (period <= 60) {
            feePercent = interest[4]
        } else {
            feePercent = interest[5]
        }
        return feePercent;
    }

    const feePercent = extracted();
    const tmpInvoiceAmount = parseInt(invoiceAmount === "" ? "0" : invoiceAmount)
    const {high, medium, low} = {
            high: Math.max(500, feePercent.high * tmpInvoiceAmount / 100),
            medium: Math.max(500, feePercent.medium * tmpInvoiceAmount / 100),
            low: Math.max(500, feePercent.low * tmpInvoiceAmount / 100)
    }

    const formatNumber = (value: number) => {
        return new Intl.NumberFormat("no-NO", { maximumSignificantDigits: 3 })
            .format(value)
    }

    const onCalculatePrice = () => {
        setShouldShowResult(true)
    }

    //const formattedInvoiceAmount = formatNumber(tmpInvoiceAmount)
    const showPrice = invoiceAmount !== "" && creditPeriod !== ""
    return (
        <Container>
            <MainHeading color="fff">Hva koster fakturasalg</MainHeading>
            <SubHeading color="fff">Med fakturasalg betaler du kun når du selger en faktura.</SubHeading>
            <p>
                Fakturasalg prises som en prosentprovisjon hvor vi tar utgangspunkt i fakturabeløpet, betalingsfristen og din kundes
                risiko. Din provisjonsprosent er fast, men prisen vil variere fra faktura til faktura og fra kunde til kunde.
                Priskalkulatoren vår gir deg en pekepinn på hvor mye det koster å selge en faktura.
            </p>
            <InputWrapper>
                <TextInput
                    type="text"
                    placeholder="Fakturabeløp"
                    onChange={onChangeInvoiceAmount}
                    value={invoiceAmount}
                />
                <TextInput
                    type="text"
                    placeholder="Dager til forfall"
                    onChange={onChangeCreditPeriod}
                    value={creditPeriod}
                />
            </InputWrapper>
            <CalculateButton onClick={onCalculatePrice}>Regn ut</CalculateButton>
            { showResult && showPrice && (
                <InputWrapper>
                    <TextInput type="text" value={formatNumber(low)} />
                    <TextInput type="text" value={formatNumber(medium)} />
                    <TextInput type="text" value={formatNumber(high)} />
                </InputWrapper>
            ) }
        </Container>
    )
}

